import {MenuItemActionBase} from "./menu-item-action-base";
import {UriPath} from "../location/uri-path/uri-path";
import {IMenuItemExecuteOptions} from "./menu-item-action.interface";
import {LinkNavigationId} from "../configurations/config-data-sections/generated-config-const";

export class LinkNavigationAction extends MenuItemActionBase {
    protected async _onClick(options?: IMenuItemExecuteOptions): Promise<void> {
        if(!this.config.linkId) {
            throw new Error(`Missing linkId for ${this.key} menu item`);
        }

        const promotionsLinks: LinkNavigationId[] = ['promotionsLink', 'promotionsCIPLink', 'promotionsCISLink'];

        try {
            if(this.services.user.isAuthorized && promotionsLinks.includes(this.config.linkId)) {
                this.services.sdk.promptPushNotificationPermissionRequest();
            }
        }
        catch (e) {
            this.services.analytics.sendElasticInfoEvent({
                eventType: "error",
                category: "navigation",
                action: "push notification permission request failed",
                value:e.toString()
            })
        }
        finally {
            await this.services.linksNavigation.navigateLink({
                linkId: this.config.linkId,
                linkHash: options?.linkHash,
                marketingParams: {
                    dl: this.config.dl
                }
            });
        }
    }

    get isMatchToCurrentUrl(): boolean {
        let link = this.getLinkUrl();
        try {
            if (!link)
                return false;

            if (link.slice(-1) === '/')  // NB: link may be "/slots/" comparing to "/slots", so trim trailing "/" from the link before comparing.
                link = link.slice(0, -1);

            const currentPath = this.services.location.currentUri.pathName;
            const candidate = new UriPath(link);

            if (currentPath.isEmpty)
                return candidate.isEmpty; // We're on the homepage, so a link to homepage is active
            if (candidate.isEmpty)
                return false; // We're *not* on the homepage, so a link to homepage is *definitely not* active

            const linkRoot = candidate.toArray()[1].toLowerCase();
            const pathRoot = currentPath.toArray()[1].toLowerCase();

            if (linkRoot !== pathRoot)
                return false; // cannot be the same link if they don't start in the same root

            return currentPath.toString().toLowerCase().indexOf(link.toLowerCase()) > -1;
        } catch(e) {
            this.services.logger.error(`Failed to compare link '${link}' to current route!`, e);
            return false;
        }
    }


}